<template>
  <b-card>
    <b-card-body>
      <b-card-title>ข้อมูลการติดต่อ :</b-card-title>
      <table class="mt-2 mt-xl-0 w-100">
        <tr>
          <th class="pb-50">
            <feather-icon icon="UserIcon" class="mr-75" />
            <span class="font-weight-bold">เบอร์โทรศัพท์ :</span>
          </th>
          <td class="pb-50">
            {{ userData.phone }}
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon icon="CheckIcon" class="mr-75" />
            <span class="font-weight-bold">อีเมล :</span>
          </th>
          <td class="pb-50 text-capitalize">
            {{ userData.email }}
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon icon="StarIcon" class="mr-75" />
            <span class="font-weight-bold">ที่อยู่ :</span>
          </th>
          <td class="pb-50 text-capitalize">
            {{ userData.shopAddress }}
          </td>
        </tr>
      </table>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BFormCheckbox,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BTable,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BFormCheckbox,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const permissionsData = [
      {
        module: "Admin",
        read: true,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: "Staff",
        read: false,
        write: true,
        create: false,
        delete: false,
      },
      {
        module: "Author",
        read: true,
        write: false,
        create: true,
        delete: false,
      },
      {
        module: "Contributor",
        read: false,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: "User",
        read: false,
        write: false,
        create: false,
        delete: true,
      },
    ];

    return {
      permissionsData,
    };
  },
};
</script>

<style></style>
